import { render, staticRenderFns } from "./RedirectTemplate.vue?vue&type=template&id=2aac0468&scoped=true"
import script from "./RedirectTemplate.vue?vue&type=script&lang=js"
export * from "./RedirectTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aac0468",
  null
  
)

export default component.exports